import axios from 'axios'

export default {
  methods: {
    sendPosterToBasket(payload) {
      return axios.post(process.env.VUE_APP_STOR_URL + '/cart/add', payload)
    },
  }
}
